import { render, staticRenderFns } from "./TriviaContents.vue?vue&type=template&id=09c83cbf&"
import script from "./TriviaContents.vue?vue&type=script&lang=js&"
export * from "./TriviaContents.vue?vue&type=script&lang=js&"
import style0 from "./TriviaContents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports